import React from 'react';
import { SideNavContextProps } from '../index.types';

export const SideNavContext = React.createContext<SideNavContextProps>({
    open: false,
    setOpen: () => {},
    dark: true,
    mobile: false,
});
